import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/pages-container/CoffretPremium.tsx");
